var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutMain',[_c('section',[_c('h1',[_vm._v("Hej "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.userName)}})]),_c('RecentItems',{attrs:{"search":_vm.searchinput}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }